module.exports = __webpack_public_path__ + "4ebff2885ebee4c0607ff24264fc5e3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Background/score.png
// module id = 630
// module chunks = 0